var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-100",
    transform: "translate(0.500000, 0.000000)",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-path",
    cx: 10,
    cy: 10,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 5,
    x2: 3,
    y2: 15.5,
    id: "Line-6",
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChangeIcon);
export default __webpack_public_path__ + "static/media/no-change-icon.2aae52972f272c9ff3d155d941549ee0.svg";
export { ForwardRef as ReactComponent };